// 엔드포인트 URL을 생성하는 함수의 타입을 정의합니다.
export interface AuthEndpointsProps {
  post_login: () => string;
  post_member_logout: () => string;
  post_admin_logout: () => string;
  post_seller_signup: () => string;
  post_seller_business_validate: () => string;
  post_password_find: () => string;
  post_identifier_send: () => string;
  post_identifier_find: () => string;
  post_identifier_check: () => string;
  post_buyer_signup: () => string;
  post_admin_signup: () => string;
  post_email_verification_code_send: () => string; // 이메일 인증 코드 전송
  post_email_verification_code_validate: () => string; // 이메일 인증 코드 확인
  get_seller_business_banks: () => string; // 은행 목록 조회
}

// 인증 관련 엔드포인트 정의
export const AuthEndpoints: AuthEndpointsProps = {
  post_login: () => `api/auth/login`,
  post_member_logout: () => `api/member/logout`,
  post_admin_logout: () => `api/admin/logout`,
  post_seller_signup: () => `api/auth/seller/signup`,
  post_seller_business_validate: () => `api/auth/seller/business/validate`,
  post_password_find: () => `api/auth/password/find`,
  post_identifier_send: () => `api/auth/identifier/send`,
  post_identifier_find: () => `api/auth/identifier/find`,
  post_identifier_check: () => `api/auth/identifier/check`,
  post_buyer_signup: () => `api/auth/buyer/signup`,
  post_admin_signup: () => `api/auth/admin/signup`,
  post_email_verification_code_send: () => `api/auth/verification-code/send`, // 이메일 인증 코드 전송
  post_email_verification_code_validate: () =>
    `api/auth/verification-code/validate`, // 이메일 인증 코드 확인
  get_seller_business_banks: () => `api/auth/seller/business/banks`, // 은행 목록 조회
};

export default AuthEndpoints;
